import { library } from "@fortawesome/fontawesome-svg-core";
import { faCirclePlus, faCircleMinus } from "@fortawesome/free-solid-svg-icons";

library.add(faCirclePlus, faCircleMinus);
